module.exports = __webpack_public_path__ + "img/rebooted.01ee25c9.svg";